import { render, staticRenderFns } from "./AzrNPCComponent.vue?vue&type=template&id=b6ee0572&scoped=true"
import script from "./AzrNPCComponent.vue?vue&type=script&lang=ts"
export * from "./AzrNPCComponent.vue?vue&type=script&lang=ts"
import style0 from "./AzrNPCComponent.vue?vue&type=style&index=0&id=b6ee0572&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ee0572",
  null
  
)

export default component.exports